// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Eric Meyer's Reset CSS v2.0 (http://meyerweb.com/eric/tools/css/reset/) customized */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
    margin: 0;
    padding: 0;
    border: 0;
    /*color: initial;*/
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
    display: block;
}
body {
    line-height: 1;
}
ol,
ul {
    list-style: none;
}
blockquote,
q {
    quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
    content: '';
    content: none;
}
table {
    border-collapse: collapse;
    border-spacing: 0;
}
input,
button {
    border: 0 none;
    background: none;
}
button {
    cursor: pointer;
}
button:focus,
a:focus,
ul:focus,
div:focus {
    outline: none;
}
select {
    border: none;
}
input:focus,
input:active,
label:focus,
label:active {
    background: none;
    border: 0 none;
    outline: none;
}
input[type='checkbox']:before,
input[type='radio']:before {
    border: medium none;
    background: none;
    border-radius: 0;
    color: #fff;
    font-size: initial;
    font-weight: normal;
    margin: 0;
    padding: 0;
    opacity: 1;
    height: auto;
    width: auto;
    -webkit-appearance: none;
    -moz-appearance: none;
}
textarea:focus {
    outline: none;
}

a {
    text-decoration: none;
}

input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

/*Autocomplete reset for chrome*/
input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
}

/*box-sizing for ALL*/
html {
    box-sizing: border-box;
}

*,
*:before,
*:after {
    box-sizing: inherit;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nearpod-packages/styles/scss/reset.css"],"names":[],"mappings":"AAAA,uFAAuF;AACvF;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAyEI,SAAS;IACT,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,wBAAwB;AAC5B;AACA;;;;;;;;;;;IAWI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;;IAEI,gBAAgB;AACpB;AACA;;IAEI,YAAY;AAChB;AACA;;;;IAII,WAAW;IACX,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;;IAEI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;;;;IAII,aAAa;AACjB;AACA;IACI,YAAY;AAChB;AACA;;;;IAII,gBAAgB;IAChB,cAAc;IACd,aAAa;AACjB;AACA;;IAEI,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,UAAU;IACV,UAAU;IACV,YAAY;IACZ,WAAW;IACX,wBAAwB;IACxB,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,8CAA8C;AAClD;;AAEA,qBAAqB;AACrB;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,mBAAmB;AACvB","sourcesContent":["/* Eric Meyer's Reset CSS v2.0 (http://meyerweb.com/eric/tools/css/reset/) customized */\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    /*color: initial;*/\n    font-size: 100%;\n    font: inherit;\n    vertical-align: baseline;\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n    display: block;\n}\nbody {\n    line-height: 1;\n}\nol,\nul {\n    list-style: none;\n}\nblockquote,\nq {\n    quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n    content: '';\n    content: none;\n}\ntable {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\ninput,\nbutton {\n    border: 0 none;\n    background: none;\n}\nbutton {\n    cursor: pointer;\n}\nbutton:focus,\na:focus,\nul:focus,\ndiv:focus {\n    outline: none;\n}\nselect {\n    border: none;\n}\ninput:focus,\ninput:active,\nlabel:focus,\nlabel:active {\n    background: none;\n    border: 0 none;\n    outline: none;\n}\ninput[type='checkbox']:before,\ninput[type='radio']:before {\n    border: medium none;\n    background: none;\n    border-radius: 0;\n    color: #fff;\n    font-size: initial;\n    font-weight: normal;\n    margin: 0;\n    padding: 0;\n    opacity: 1;\n    height: auto;\n    width: auto;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n}\ntextarea:focus {\n    outline: none;\n}\n\na {\n    text-decoration: none;\n}\n\ninput {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n/*Autocomplete reset for chrome*/\ninput:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px white inset;\n}\n\n/*box-sizing for ALL*/\nhtml {\n    box-sizing: border-box;\n}\n\n*,\n*:before,\n*:after {\n    box-sizing: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
